import validationRules from "../validationRules";
validationRules.register("float", function (record, fieldMetadataMap, fieldName, t) {
    var value = record[fieldName];
    if (!value) {
        return true;
    }
    var result = /^[+-]?((\.\d+)|(\d+(\.\d+)?))$/.test(value);
    if (result) {
        return true;
    }
    return "should be float.";
});
